import React, { useState } from "react";
import { message } from "antd";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import drEasyApi from "../../../Api/Customapi";
import { useLanguage } from "../../../context/LanguageContext";

const ChangePassword = ({ slug, token }) => {
  const { t } = useLanguage();
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [show, setShow] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const toggleVisibility = (field) => {
    setShow((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      message.warning(t('settings.changePassword.fillAllFields'));
      return;
    }

    if (form.newPassword.length < 6) {
      message.warning(t('settings.changePassword.minLength'));
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      message.warning(t('settings.changePassword.passwordMismatch'));
      return;
    }

    try {
      setLoading(true);
      const res = await drEasyApi.put(
        `/api/${slug}/User/ChangePassword`,
        {
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
          confirmPassword: form.confirmPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.isSuccessStatusCode || res.status === 200) {
        message.success(t('settings.changePassword.success'));
        setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
      } else {
        message.error(res.data?.message || t('settings.changePassword.error'));
      }
    } catch (error) {
      console.error(error);
      if(error.response.data[0].includes("Incorrect password")) {
        message.warning(t('settings.changePassword.incorrectPassword'));
      } else {
        message.error(error.response.data[0]);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto mt-12 bg-white p-6 shadow rounded-lg">
      <h2 className="text-xl font-bold mb-4 text-primary">{t('settings.changePassword.title')}</h2>
      <form onSubmit={handleSubmit} className="grid gap-4">
        {/* Current Password */}
        <div>
          <label className="text-sm font-medium">{t('settings.changePassword.currentPassword')}</label>
          <div className="relative">
            <input
              type={show.current ? "text" : "password"}
              name="currentPassword"
              value={form.currentPassword}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded pr-10"
              required
            />
            <button
              type="button"
              onClick={() => toggleVisibility("current")}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
            >
              {show.current ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {/* New Password */}
        <div>
          <label className="text-sm font-medium">{t('settings.changePassword.newPassword')}</label>
          <div className="relative">
            <input
              type={show.new ? "text" : "password"}
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded pr-10"
              required
            />
            <button
              type="button"
              onClick={() => toggleVisibility("new")}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
            >
              {show.new ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {/* Confirm Password */}
        <div>
          <label className="text-sm font-medium">{t('settings.changePassword.confirmPassword')}</label>
          <div className="relative">
            <input
              type={show.confirm ? "text" : "password"}
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded pr-10"
              required
            />
            <button
              type="button"
              onClick={() => toggleVisibility("confirm")}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
            >
              {show.confirm ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-primary text-white py-2 rounded disabled:opacity-50"
        >
          {loading ? t('settings.changePassword.changing') : t('settings.changePassword.changeButton')}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;